export default "__VITE_ASSET__CodkrCbb__"